import type {FirebaseOptions} from "@firebase/app";

export const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyCH1M9UwqZihSxC-1C_885wbc_RipuVhwg",
  authDomain: "doyacguide-1514011393591.firebaseapp.com",
  databaseURL: "https://doyacguide-1514011393591.firebaseio.com",
  projectId: "doyacguide-1514011393591",
  storageBucket: "doyacguide-1514011393591.firebasestorage.app",
  messagingSenderId: "1087845376297",
  appId: "1:1087845376297:web:35d2b1cee652e025b59738",
  measurementId: "G-RPV4XG3QQZ"
}

export const vapidKey = 'BGljR1xUsIctATHXrxOSuDPg9cPNDS2rXfd8x_HP4dXAUf5oyclk5mJR325xFhA5ZR8fTuLeNJgo7DG0qinhzzo'
